(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /**
   * Encuentra el sidebar de filtros: la hija directa de .collection-wrapper
   * que contiene 2 o más <details>.
   */
  const findFilterSidebars = () => {
    const wrappers = document.querySelectorAll('.collection-wrapper');
    const sidebars = [];
    wrappers.forEach((wrapper) => {
      Array.from(wrapper.children).forEach((child) => {
        if (child.querySelectorAll('details').length >= 2) {
          sidebars.push(child);
        }
      });
    });
    return sidebars;
  };

  const forceOpenSidebar = (sidebar) => {
    sidebar.querySelectorAll('details').forEach((d) => {
      if (!d.hasAttribute('open')) d.setAttribute('open', '');
    });
    sidebar.querySelectorAll('details > [hidden]').forEach((el) => {
      if (el.tagName !== 'SUMMARY') el.removeAttribute('hidden');
    });
  };

  let applying = false;

  const setupSidebar = (sidebar) => {
    if (!sidebar.classList.contains('custom-filters-styled')) {
      sidebar.classList.add('custom-filters-styled');
    }
    forceOpenSidebar(sidebar);

    sidebar.querySelectorAll('details').forEach((d) => {
      if (d.dataset.cfObserved === '1') return;
      d.dataset.cfObserved = '1';
      const obs = new MutationObserver(() => {
        if (!d.hasAttribute('open')) {
          applying = true;
          d.setAttribute('open', '');
          applying = false;
        }
      });
      obs.observe(d, { attributes: true, attributeFilter: ['open'] });
    });
  };

  const setupAll = () => {
    if (applying) return;
    applying = true;
    findFilterSidebars().forEach(setupSidebar);
    applying = false;
  };

  // Re-aplicar cuando el tema reemplaza el sidebar tras filtrar (AJAX)
  const observeCollectionWrappers = () => {
    document.querySelectorAll('.collection-wrapper').forEach((wrapper) => {
      if (wrapper.dataset.cfWrapperObserved === '1') return;
      wrapper.dataset.cfWrapperObserved = '1';
      const obs = new MutationObserver(() => {
        if (applying) return;
        requestAnimationFrame(setupAll);
      });
      obs.observe(wrapper, { childList: true, subtree: true });
    });
  };

  const init = () => {
    setupAll();
    observeCollectionWrappers();
  };

  // Bloquea el toggle al hacer clic en el summary
  document.addEventListener(
    'click',
    (e) => {
      const summary = e.target.closest('.custom-filters-styled details > summary');
      if (summary) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);

  } catch(e) { console.error(e); }
})();
})();
